  <div *ngIf="isConnectionModalShown"
    id="SubscribeBoxModal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    [config]="{ show: true,backdrop: masterService.modals_backdrop.isOnline }"
    (onHidden)="onHidden()"
    bsModal #autoShownModal="bs-modal" style="z-index: 111111;">
    <div class="custom-theme-modal modal-dialog modal-md">
      <div class="modal-content">
        <div class="modal-header pt-3">
          <span
            class="float-right"
            data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true"
              (click)="hideModal()">
              <span>&#x2715;</span>
            </span>
          </span>
        </div>
        <div class="modal-body">
          <div class="pb-3 text-center">
            <p class="heading-3">{{mls2?.languageText?.internet_connection_modal?.key1}}
              <span *ngIf="mls2?.is_lskey_display == 1">(internet_connection_modal.key1)</span>
            </p>
            <p class="paragraph mt-3">{{mls2?.languageText?.internet_connection_modal?.key2}}
              <span *ngIf="mls2?.is_lskey_display == 1">(internet_connection_modal.key2)
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
   </div>
